// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--font-size-base: 14px;
	--font-size-sm: 13px;
	--font-size-title: 16px;
	--font-size-stat: 22px;
	--color-text: #1f2937;
	--color-text-secondary: #4b5563;
	--color-brand: #053380;
	--color-brand-dark: #0b1f4d;
	--color-error: #d9001b;
	--color-bg-app: #f4f6fb;
}

@media(max-width:767px) {
	.btn.de-in-se {
		width: 40px !important
	}

	.paginate.de-se-in {
		position: relative;
		left: 4%
	}
}

.paginate {
	text-align: center
}

input.modal-input.video_appointment_class.numbervalidation {
	border: 1px solid red !important
}

button#closeVideoCall {
	display: none
}

.leave-meeting {
	padding: 15px;
	height: 95%;
	position: relative
}

.leave-meeting p {
	text-align: center !important;
	font-size: 22px;
	height: 30px;
	display: table-cell;
	vertical-align: middle;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto
}

.search-box-inventroy.detailpage {
	width: 100%;
	height: 100%;
	padding-top: 1%;
	padding-bottom: 2%
}

iframe#myFrame {
	height: 100% !important;
	width: 100% !important
}

a.browse-inventory.redefining-width.videocallinitiator {
	width: 100% !important
}

button.btn.btn-default.btn-sm.closethiscall {
	width: 24%;
	height: 6%;
	padding-top: 15px;
	padding-bottom: 29px;
	position: absolute;
	background: #e52e2e;
	border-radius: 0;
	box-shadow: 0 8px 15px rgba(0, 0, 0, .1);
	right: 10px;
	bottom: 4px;
	display: none !important
}

.videocallclose {
	z-index: 9 !important;
	position: fixed !important;
	right: 17px !important;
	top: 8px !important
}

p.text-center.ifnotavailable {
	font-size: 3em;
	margin-top: 30%;
	font-weight: 900;
	line-height: 1.6em
}

.overlay_for_video {
	position: fixed;
	display: grid;
	width: 100%;
	height: 95%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #f4b136fc;
	z-index: 2;
	cursor: pointer
}

.new-popup-form .time-slot {
	position: relative
}

.new-popup-form .time-slot:before {
	position: absolute;
	left: 0;
	top: -30px;
	line-height: 30px;
	background: #333;
	color: #fff;
	padding: 0 15px;
	content: "";
	border-radius: 5px;
	display: none
}

.new-popup-form .time-slot:hover:before {
	display: block
}

.new-popup-form .time-slot.busy_hour:before {
	content: "Busy Hours"
}

.new-popup-form .time-slot.slightly_busy:before {
	content: "Slightly Busy"
}

.new-popup-form .time-slot.normal_hour:before {
	content: "0 Wait Time"
}

.new-popup-form .time-slot.busy_hour {
	border: 1px solid red
}

.new-popup-form .time-slot.slightly_busy {
	border: 1px solid orange
}

.new-popup-form .time-slot.normal_hour {
	border: 1px solid #c4161c
}

.slot-hint span {
	font-size: 10px;
	width: 33%;
	display: flex;
	line-height: 15px
}

.slot-hint {
	display: flex;
	margin-bottom: 10px;
	padding-left: 15px
}

.slot-hint span i {
	width: 15px;
	height: 15px;
	margin-right: 10px
}

.slot-busy-hours i {
	border: 1px solid red
}

.slot-slight-hours i {
	border: 1px solid #f75205
}

.slot-normal-hours i {
	border: 1px solid #c4161c
}

.swal-overlay.swal-overlay--show-modal {
	z-index: 99999
}

select.timeslots.dropdown-toggle {
	font-size: 15px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	color: #8f9bb3;
	height: 48px;
	border-radius: 4px;
	border: solid 1px #e4e9f2;
	background-color: #f7f9fc;
	width: 100%
}

a.store-details i.fa.fa-whatsapp {
	position: relative;
	top: 2px;
	left: 8px;
	color: #25d366
}

div#free-eyecheckup {
	display: none
}

#google-reviews {
	margin: 0 auto
}

.checked {
	color: orange
}

.rating-process {
	width: 48%
}

.bar-container {
	width: 100%;
	background-color: #f1f1f1;
	text-align: center;
	color: #fff;
	margin-top: 9px;
	border-radius: 10px
}

.bar-container div {
	border-radius: 3px
}

.bar-5 {
	width: 60%;
	height: 10px;
	background-color: #4caf50
}

.bar-4 {
	width: 30%;
	height: 10px;
	background-color: #2196f3
}

.bar-3 {
	width: 10%;
	height: 10px;
	background-color: #00bcd4
}

.bar-2 {
	width: 4%;
	height: 10px;
	background-color: #ff9800
}

.bar-1 {
	width: 15%;
	height: 10px;
	background-color: #f44336
}

.rating {
	border: none
}

.start-rating {
	margin: 0 15px 0 0
}

.start-rating ul {
	padding: 0;
	list-style: none;
	margin: 7px 0 0
}

.start-rating ul li {
	margin-top: 5px;
	font-size: 12px
}

#google-reviews .row {
	display: flex;
	margin: 0
}

.average-rating {
	text-align: center;
	width: 35%
}

.rating {
	border: none;
	padding: 5px 0;
	width: 100px;
	margin: auto
}

.average {
	font-size: 36px;
	margin-top: 20px
}

.all-reviews {
	font-size: 12px;
	color: #2e3a59
}

#google-reviews p {
	margin-bottom: 5px
}

.reviews__content {
	padding: 0;
	list-style: none;
	margin: 20px 0 0
}

.reviews__content::-webkit-scrollbar {
	width: 5px;
	position: relative;
	top: 30px
}

.reviews__content::-webkit-scrollbar-thumb {
	background: #a6a6a6;
	position: relative;
	top: 30px
}

.reviews__content::-webkit-scrollbar-thumb:hover {
	background: #c4161c
}

.reviews__content li {
	margin: 0 0 20px;
	padding: 10px 12px 15px;
	background: #f7f9fc;
	border-radius: 0 30px 0 30px
}

.heading {
	text-transform: uppercase;
	text-align: center;
	margin: 0;
	padding: 0;
	font-size: 30px;
	font-weight: 700;
	margin-bottom: 20px;
	font-family: rajdhani, sans-serif;
	color: #505050
}

.eyecheckup-btn {
	text-align: right
}

.badge-pill {
	padding: .5em 1em;
	font-size: 10px;
	font-weight: 400;
	margin-right: 5px;
	margin-bottom: 5px;
	border-radius: 0
}

.badge-light {
	color: #000;
	background-color: #f4f4f4;
	border: 1px solid #adadad
}

.star-ratings-css {
	unicode-bidi: bidi-override;
	color: #c5c5c5;
	font-size: 25px;
	height: 25px;
	width: 100px;
	margin: 0 auto;
	position: relative;
	padding: 0;
	text-shadow: 0 1px 0 #a2a2a2
}

.store-tags h3 {
	font-size: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid #adadad;
	padding-bottom: 10px;
	font-weight: 600;
	font-family: rajdhani, sans-serif
}

.star-ratings-css-top {
	color: #e7711b;
	padding: 0;
	position: absolute;
	z-index: 1;
	display: block;
	top: 0;
	left: 0;
	overflow: hidden
}

.star-ratings-css-bottom {
	padding: 0;
	display: block;
	z-index: 0
}

.star-ratings-sprite {
	font-size: 0;
	height: 21px;
	line-height: 0;
	overflow: hidden;
	text-indent: -999em;
	width: 80px;
	margin: 0 auto;
	background-size: 16px
}

.star-ratings-sprite-rating {
	float: left;
	height: 18px;
	display: block;
	background-size: 16px
}

.reviews__review-er.avatar_image {
	width: 55px;
	border-radius: 50%;
	margin-right: 15px;
	float: left;
	border: 1px solid #eee;
	padding: 0;
	margin-top: 0
}

.reviews__review-er {
	margin-bottom: 7px;
	color: #2e3a59;
	margin-top: 9px;
	font-size: 16px
}

.detail-search p {
	font-weight: 400;
	line-height: 20px
}

.store-container {
	overflow: hidden;
	display: flex
}

.reviews__review-date {
	font-size: 10px;
	font-weight: 400;
	margin-top: 3px;
	position: absolute;
	right: 0
}

.reviews__review-comment {
	margin-top: 6px;
	font-weight: 400;
	font-size: 12px;
	line-height: normal;
	clear: both
}

.reviews__review-rating {
	font-weight: 300;
	font-size: 11px;
	display: flex;
	position: relative
}

.user-rating {
	width: 80px
}

.user-rating .star-ratings-sprite-rating {
	float: none;
	display: inline-block
}

.toggle-content {
	display: none
}

.toggle {
	color: #c4161c;
	text-decoration: underline
}

.user_login_message {
	font-family: rajdhani, sans-serif;
	color: #e81445
}

.store-name {
	padding: 12px 12px 4px;
	position: absolute;
	bottom: -27px;
	left: 0;
	right: 0
}

.store-name span {
	display: block
}

.store-name span {
	color: #c4161c;
	font-size: 16px;
	font-weight: 500;
	font-family: futura book;
	text-decoration: none;
	padding-bottom: 5px;
	position: static
}

#appointment-modal h4 {
	text-align: center;
	font-size: 16px;
	margin-bottom: 20px;
	border-bottom: 1px solid #e4e9f2;
	margin: 0 -16px 16px;
	padding-bottom: 12px;
	font-weight: 600
}

#appointment .input-block {
	margin-bottom: 20px;
	margin-top: 20px
}

#video_appointment .input-block {
	margin-bottom: 20px;
	margin-top: 20px
}

#appointment .input-block label {
	width: 40%;
	font-weight: 400
}

#video_appointment .input-block label {
	width: 40%;
	font-weight: 400
}

#appointment .input-block input,
.optional input,
.chosen-select {
	width: 59%;
	height: 35px;
	background: #f7f9fc;
	color: #222b45;
	font-size: 13px;
	border-radius: 4px;
	font-weight: 400;
	border: 1px solid #e4e9f2;
	padding: 0 5px
}

#video_appointment .input-block input,
.optional input,
.chosen-select {
	width: 59%;
	height: 35px;
	background: #f7f9fc;
	color: #222b45;
	font-size: 13px;
	border-radius: 4px;
	font-weight: 400;
	border: 1px solid #e4e9f2;
	padding: 0 5px
}

.optional {
	padding: 6px 0
}

.optional input {
	width: 100%
}

#appointment fieldset {
	margin-bottom: 10px
}

#video_appointment fieldset {
	margin-bottom: 10px
}

.select-day-time {
	border: 1px solid #eee;
	padding: 20px 15px 10px
}

.day-block {
	display: inline-block;
	width: 13.6%;
	text-align: center;
	padding: 10px 0;
	transition: .4s;
	cursor: pointer;
	background: #000;
	color: #fff;
	margin: 0 !important
}

.day-block span {
	display: block;
	margin: 6px 0
}

.time-slot {
	display: inline-block;
	width: 24.2%;
	text-align: center;
	border: 2px solid #e4e9f2;
	padding: 10px;
	font-weight: 400;
	padding: 15px 0;
	border-radius: 4px;
	cursor: pointer;
	transition: .4s;
	font-size: 12px;
	font-weight: revert
}

.time-slot:hover,
.time-slot.active {
	border: 2px solid #c4161c;
	color: #c4161c
}

.whats-rem input[type=checkbox]+label {
	display: block;
	margin: .2em;
	cursor: pointer;
	padding: .2em
}

.whats-rem input[type=checkbox] {
	display: none
}

.whats-rem input[type=checkbox]+label:before {
	content: "\\2714";
	border: .1em solid #000;
	border-radius: .2em;
	display: inline-block;
	width: 18px;
	height: 18px;
	padding-left: 0;
	padding-bottom: 0;
	margin-right: 5px;
	vertical-align: bottom;
	color: transparent;
	transition: .2s;
	margin-top: 15px
}

.whats-rem input[type=checkbox]+label:active:before {
	transform: scale(0)
}

.whats-rem input[type=checkbox]:checked+label:before {
	background-color: MediumSeaGreen;
	border-color: MediumSeaGreen;
	color: #fff
}

.day-block:hover,
.day-block.active {
	background: #c9edea
}

.modal-dialog {
	max-width: 700px
}

.submitBtnLead {
	margin-top: -10px;
	font-weight: 400;
	padding: 12px 10px;
	cursor: pointer;
	position: relative;
	top: -8px
}

.time-slot-field,
.day-group {
	text-align: center
}

.time-slot-field label,
.day-group label {
	margin: 18px 0 15px;
	color: #505050
}

.day-group label {
	margin-top: 0
}

.disabled {
	cursor: not-allowed;
	cursor: not-allowed
}

.disabled:hover {
	border-color: #e4e9f2;
	color: #444
}

div#mapFullScreen div {
	color: #f7f9fc !important
}

.mobileview {
	display: none
}

.tel span {
	background: #ed1b24;
	padding: 1px 15px;
	color: #fff;
	float: right;
	margin-right: 0;
	font-size: 13px;
	margin-left: 30px
}

#scroll {
	position: fixed;
	right: 10px;
	bottom: 10px;
	cursor: pointer;
	width: 50px;
	height: 50px;
	background-color: #c4161c;
	text-indent: -9999px;
	display: none;
	border-radius: 60px
}

#scroll span {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -8px;
	margin-top: -12px;
	height: 0;
	width: 0;
	border: 8px solid transparent;
	border-bottom-color: #fff
}

#scroll:hover {
	background-color: #f26522;
	opacity: 1;
	filter: "alpha(opacity=100)";
	-ms-filter: "alpha(opacity=100)"
}

a#whatsappimage {
	display: none
}

.loc-pin {
	max-width: 5%
}

.eyecheckup {
	background: linear-gradient(80deg, #31b2b0, #edbc31)
}

.eyecheckup:hover {
	background: linear-gradient(80deg, #31b2b0, #edbc31)
}

@media all and (max-width: 1024px) and (min-width: 768px) {
	.payment ul li {
		font-size: 10px
	}

	.store-name span {
		font-size: 14px
	}

	.rating-process {
		width: 40%
	}

	.average {
		font-size: 32px
	}

	.start-rating ul li {
		margin-top: 6px
	}

	.reviews__review-date {
		position: static;
		padding-top: 30px
	}

	.reviews__review-rating {
		display: block
	}

	#content.detail-search .nearby-stores-content .store-info {
		width: 50%
	}

	.heading {
		font-size: 26px
	}

	.user-rating {
		position: absolute;
		left: 67px
	}

	.tabletview {
		float: right
	}

	.navbar-brand {
		padding: 0
	}

	.upper-part .btn {
		float: right;
		margin-top: 12px
	}

	.upper-part .col-md-12.d-md-flex {
		display: block !important
	}
}

@media all and (max-width: 767px) {
	.slot-hint {
		margin-bottom: 20px;
		padding-left: 0
	}

	.new-popup-form .time-slot:before {
		width: 76px;
		text-align: center;
		font-size: 10px;
		padding: 0
	}

	.new-popup-form .time-slot-field:last-child {
		text-align: left;
		margin: 5px 0 0
	}

	#free-eyecheckup {
		width: auto;
		text-align: right;
		font-size: 12px;
		margin-top: 9px;
		display: none !important;
		text-transform: uppercase;
		font-family: Rajdhani, sans-serif;
		font-weight: 600;
		border: 1px solid #c9edea;
		border-radius: 25px;
		padding: 10px 8px 3px 10px;
		background: #c9edea;
		box-shadow: 0 2px 20px rgba(46, 229, 157, .4);
		cursor: pointer
	}

	#free-eyecheckup i.fa.fa-whatsapp {
		color: #4ac959;
		font-size: 20px;
		float: right;
		margin-left: -17px;
		padding-left: 23px;
		margin-top: -4px
	}

	#free-eyecheckup a {
		color: #505050;
		text-decoration: none;
		font-weight: 700
	}

	.navbar-brand {
		padding: 0;
		width: 50%;
		margin-right: 0
	}

	.upper-part .btn {
		float: right;
		margin-top: 13px
	}

	.upper-part .col-md-12.d-md-flex {
		display: block !important
	}

	.tel-mobile img {
		width: 25px
	}

	.lenskart-offer-desk.showthis.home.desktopview {
		display: none
	}

	#scroll {
		right: 22px;
		bottom: 60px
	}

	a#whatsappimage {
		display: block;
		position: fixed;
		bottom: 10px;
		right: 22px
	}

	a#whatsappimage img {
		filter: drop-shadow(2px 2px 2px #989898);
		width: 135px
	}

	ul#reviews__content,
	.list-view-sidebar {
		height: auto;
		overflow-y: initial
	}

	#google-reviews {
		margin-top: 30px
	}

	.modal-open .modal {
		padding-right: 0 !important
	}

	.day-block {
		width: 13%
	}

	.time-slot {
		width: 49%;
		margin-bottom: 10px
	}

	#appointment .input-block input,
	.optional input,
	.chosen-select {
		width: 53%
	}

	#video_appointment .input-block input,
	.optional input,
	.chosen-select {
		width: 53%
	}

	#video_appointment .input-block label {
		width: 44%
	}

	#appointment .input-block label {
		width: 44%
	}

	.mobileview {
		display: block
	}

	.desktopview {
		display: none
	}

	a.tel-mobile {
		margin: 12px 0 0 8px
	}
}

@media all and (max-width: 479px) {

	.heading,
	#content.detail-search h1 {
		font-size: 24px
	}

	.heading,
	#content.detail-search h1 {
		text-align: center
	}

	.upper-part .btn {
		font-size: 11px
	}

	.imgs-grid .imgs-grid-image .image-wrap {
		display: block
	}
}

@media all and (max-width: 360px) {
	.select-day-time {
		padding-right: 8px;
		padding-left: 8px
	}
}

@media all and (max-width: 359px) {
	.day-block {
		width: 12%
	}

	#free-eyecheckup {
		font-size: 10px;
		margin-top: 10px
	}
}

.ant-card-head {
	background-color: #00000014;
	border-bottom: 1px solid #00000014 !important;
	min-height: unset;

}



.ant-card {
	min-height: 120px;
	border: 1px solid #00000014 !important;
	border-radius: .35rem;
	box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;

}

.ant-card-head-title {
	font-family: 'Merriweather Sans', sans-serif;
}



.ant-row-center {
	justify-content: unset;
}

.ant-layout-header {
	height: unset !important;
}

.ant-card-head {
	padding: unset;
}

.ant-layout-content-center {
	display: flex;
	justify-content: center;
}

.ant-layout-content-login form {
	margin-top: 60px;
	width: 400px;
	border: 1px solid #053380 !important;
	border-radius: .35rem;
	padding: 20px;
	box-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;
}

.ant-form-item-control-input-content-login button {
	width: 100%
}

.ant-col-24.ant-form-item-label {
	padding: 0px;
}

.ant-layout-content form label {
	font-size: var(--font-size-base);
	font-weight: 500;
	color: var(--color-text);
}

.ant-form-item-explain-error {
	font-size: var(--font-size-sm);
	font-weight: 500;
	color: var(--color-error) !important;
}

.ant-form-item-has-error .ant-input-affix-wrapper,
.ant-form-item-has-error .ant-input,
.ant-form-item-has-error .ant-picker {
	border-color: var(--color-error);
}

/* .ant-input {padding: 8px 11px !important;} */

/* dashboard report cards: light pastel backgrounds (set per row in the report files) with dark readable text */
.report-card {
	height: 200px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.report-card .ant-card-head {
	color: var(--color-text);
	border-bottom-color: rgba(0, 0, 0, 0.12);
}

.report-card .ant-card-head-title {
	padding: 10px;
	font-size: var(--font-size-sm);
	color: var(--color-text) !important;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.report-card .ant-card-body {
	text-align: center;
	padding: 16px 12px;
}

.report-card .ant-card-body a {
	color: var(--color-brand-dark) !important;
	font-size: var(--font-size-stat);
	font-weight: 600;
	text-decoration: none;
}

.report-card .ant-card-body a:hover {
	text-decoration: underline;
}

.report-card .ant-card-body hr {
	border-color: rgba(0, 0, 0, 0.3);
	margin: 6px 0;
}

/* tables on the listing pages */
button + .ant-table-wrapper,
.ant-space + .ant-table-wrapper {
	margin-top: 16px;
}

.ant-table-wrapper .ant-table-thead > tr > th.ant-table-cell {
	background: #eef2f8;
	color: #1f2937;
	font-weight: 600;
}

.ant-table-wrapper .ant-table-tbody > tr > td.ant-table-cell {
	padding: 10px 12px;
	word-break: break-word;
}

.ant-table-wrapper .ant-table-tbody > tr:hover > td.ant-table-cell {
	background: #f5f8ff;
}

/* app background */
body {
	background-color: var(--color-bg-app);
	color: var(--color-text);
	font-size: var(--font-size-base);
}
`, "",{"version":3,"sources":["webpack://./src/assets/index.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,+BAA+B;CAC/B,sBAAsB;CACtB,2BAA2B;CAC3B,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,WAAW;CACX;AACD;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,SAAS;CACT;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf;AACD;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,UAAU;CACV,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,wCAAwC;CACxC,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,qBAAqB;CACrB,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,WAAW;CACX,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,2BAA2B;CAC3B,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,UAAU;CACV,aAAa;CACb;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,iBAAiB;CACjB,sBAAsB;CACtB,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC,SAAS;CACT,YAAY;CACZ;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CACZ;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB;AACD;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB;AACD;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,iCAAiC;CACjC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,2BAA2B;CAC3B,cAAc;CACd,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gCAAgC;CAChC,oBAAoB;CACpB,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,MAAM;CACN,OAAO;CACP;AACD;;AAEA;CACC,UAAU;CACV,cAAc;CACd;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;CACX,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,sBAAsB;CACtB,UAAU;CACV;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,iCAAiC;CACjC;AACD;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,mBAAmB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,gCAAgC;CAChC,oBAAoB;CACpB,oBAAoB;CACpB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;;;CAGC,UAAU;CACV,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,UAAU;CACV,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,eAAe;CACf;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,eAAe;CACf,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,oBAAoB;CACpB,aAAa;CAGb;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,iBAAiB;CACjB,iBAAiB;CACjB,SAAS;CACT,QAAQ;CACR,6BAA6B;CAC7B;AACD;;AAEA;CACC,yBAAyB;CACzB,UAAU;CACV,4BAA4B;CAC5B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,kBAAkB;EAClB;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,YAAY;EACZ;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB;CACD;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf;CACD;;CAEA;EACC,gBAAgB;EAChB;CACD;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,6CAA6C;EAC7C;CACD;;CAEA;EACC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;CACD;;CAEA;EACC,cAAc;EACd,qBAAqB;EACrB;CACD;;CAEA;EACC,UAAU;EACV,UAAU;EACV;CACD;;CAEA;EACC,YAAY;EACZ;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,WAAW;EACX;CACD;;CAEA;EACC,cAAc;EACd,eAAe;EACf,YAAY;EACZ;CACD;;CAEA;EACC,wCAAwC;EACxC;CACD;;CAEA;;EAEC,YAAY;EACZ;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC,UAAU;EACV;CACD;;CAEA;;;EAGC;CACD;;CAEA;;;EAGC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;;CAEC;;EAEC;CACD;;CAEA;;EAEC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC,eAAe;EACf;CACD;AACD;;AAEA;CACC,2BAA2B;CAC3B,6CAA6C;CAC7C,iBAAiB;;AAElB;;;;AAIA;CACC,iBAAiB;CACjB,sCAAsC;CACtC,qBAAqB;CACrB,+DAA+D;;AAEhE;;AAEA;CACC,4CAA4C;AAC7C;;;;AAIA;CACC,sBAAsB;AACvB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,oCAAoC;CACpC,qBAAqB;CACrB,aAAa;CACb,+DAA+D;AAChE;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,oCAAoC;AACrC;;AAEA;;;CAGC,gCAAgC;AACjC;;AAEA,+CAA+C;;AAE/C,+GAA+G;AAC/G;CACC,aAAa;CACb,yCAAyC;AAC1C;;AAEA;CACC,wBAAwB;CACxB,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mCAAmC;CACnC,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;CAChC,aAAa;AACd;;AAEA,gCAAgC;AAChC;;CAEC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,mBAAmB;AACnB;CACC,qCAAqC;CACrC,wBAAwB;CACxB,gCAAgC;AACjC","sourcesContent":[":root {\n\t--font-size-base: 14px;\n\t--font-size-sm: 13px;\n\t--font-size-title: 16px;\n\t--font-size-stat: 22px;\n\t--color-text: #1f2937;\n\t--color-text-secondary: #4b5563;\n\t--color-brand: #053380;\n\t--color-brand-dark: #0b1f4d;\n\t--color-error: #d9001b;\n\t--color-bg-app: #f4f6fb;\n}\n\n@media(max-width:767px) {\n\t.btn.de-in-se {\n\t\twidth: 40px !important\n\t}\n\n\t.paginate.de-se-in {\n\t\tposition: relative;\n\t\tleft: 4%\n\t}\n}\n\n.paginate {\n\ttext-align: center\n}\n\ninput.modal-input.video_appointment_class.numbervalidation {\n\tborder: 1px solid red !important\n}\n\nbutton#closeVideoCall {\n\tdisplay: none\n}\n\n.leave-meeting {\n\tpadding: 15px;\n\theight: 95%;\n\tposition: relative\n}\n\n.leave-meeting p {\n\ttext-align: center !important;\n\tfont-size: 22px;\n\theight: 30px;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: auto\n}\n\n.search-box-inventroy.detailpage {\n\twidth: 100%;\n\theight: 100%;\n\tpadding-top: 1%;\n\tpadding-bottom: 2%\n}\n\niframe#myFrame {\n\theight: 100% !important;\n\twidth: 100% !important\n}\n\na.browse-inventory.redefining-width.videocallinitiator {\n\twidth: 100% !important\n}\n\nbutton.btn.btn-default.btn-sm.closethiscall {\n\twidth: 24%;\n\theight: 6%;\n\tpadding-top: 15px;\n\tpadding-bottom: 29px;\n\tposition: absolute;\n\tbackground: #e52e2e;\n\tborder-radius: 0;\n\tbox-shadow: 0 8px 15px rgba(0, 0, 0, .1);\n\tright: 10px;\n\tbottom: 4px;\n\tdisplay: none !important\n}\n\n.videocallclose {\n\tz-index: 9 !important;\n\tposition: fixed !important;\n\tright: 17px !important;\n\ttop: 8px !important\n}\n\np.text-center.ifnotavailable {\n\tfont-size: 3em;\n\tmargin-top: 30%;\n\tfont-weight: 900;\n\tline-height: 1.6em\n}\n\n.overlay_for_video {\n\tposition: fixed;\n\tdisplay: grid;\n\twidth: 100%;\n\theight: 95%;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: #f4b136fc;\n\tz-index: 2;\n\tcursor: pointer\n}\n\n.new-popup-form .time-slot {\n\tposition: relative\n}\n\n.new-popup-form .time-slot:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: -30px;\n\tline-height: 30px;\n\tbackground: #333;\n\tcolor: #fff;\n\tpadding: 0 15px;\n\tcontent: \"\";\n\tborder-radius: 5px;\n\tdisplay: none\n}\n\n.new-popup-form .time-slot:hover:before {\n\tdisplay: block\n}\n\n.new-popup-form .time-slot.busy_hour:before {\n\tcontent: \"Busy Hours\"\n}\n\n.new-popup-form .time-slot.slightly_busy:before {\n\tcontent: \"Slightly Busy\"\n}\n\n.new-popup-form .time-slot.normal_hour:before {\n\tcontent: \"0 Wait Time\"\n}\n\n.new-popup-form .time-slot.busy_hour {\n\tborder: 1px solid red\n}\n\n.new-popup-form .time-slot.slightly_busy {\n\tborder: 1px solid orange\n}\n\n.new-popup-form .time-slot.normal_hour {\n\tborder: 1px solid #c4161c\n}\n\n.slot-hint span {\n\tfont-size: 10px;\n\twidth: 33%;\n\tdisplay: flex;\n\tline-height: 15px\n}\n\n.slot-hint {\n\tdisplay: flex;\n\tmargin-bottom: 10px;\n\tpadding-left: 15px\n}\n\n.slot-hint span i {\n\twidth: 15px;\n\theight: 15px;\n\tmargin-right: 10px\n}\n\n.slot-busy-hours i {\n\tborder: 1px solid red\n}\n\n.slot-slight-hours i {\n\tborder: 1px solid #f75205\n}\n\n.slot-normal-hours i {\n\tborder: 1px solid #c4161c\n}\n\n.swal-overlay.swal-overlay--show-modal {\n\tz-index: 99999\n}\n\nselect.timeslots.dropdown-toggle {\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tline-height: 1.33;\n\tletter-spacing: normal;\n\tcolor: #8f9bb3;\n\theight: 48px;\n\tborder-radius: 4px;\n\tborder: solid 1px #e4e9f2;\n\tbackground-color: #f7f9fc;\n\twidth: 100%\n}\n\na.store-details i.fa.fa-whatsapp {\n\tposition: relative;\n\ttop: 2px;\n\tleft: 8px;\n\tcolor: #25d366\n}\n\ndiv#free-eyecheckup {\n\tdisplay: none\n}\n\n#google-reviews {\n\tmargin: 0 auto\n}\n\n.checked {\n\tcolor: orange\n}\n\n.rating-process {\n\twidth: 48%\n}\n\n.bar-container {\n\twidth: 100%;\n\tbackground-color: #f1f1f1;\n\ttext-align: center;\n\tcolor: #fff;\n\tmargin-top: 9px;\n\tborder-radius: 10px\n}\n\n.bar-container div {\n\tborder-radius: 3px\n}\n\n.bar-5 {\n\twidth: 60%;\n\theight: 10px;\n\tbackground-color: #4caf50\n}\n\n.bar-4 {\n\twidth: 30%;\n\theight: 10px;\n\tbackground-color: #2196f3\n}\n\n.bar-3 {\n\twidth: 10%;\n\theight: 10px;\n\tbackground-color: #00bcd4\n}\n\n.bar-2 {\n\twidth: 4%;\n\theight: 10px;\n\tbackground-color: #ff9800\n}\n\n.bar-1 {\n\twidth: 15%;\n\theight: 10px;\n\tbackground-color: #f44336\n}\n\n.rating {\n\tborder: none\n}\n\n.start-rating {\n\tmargin: 0 15px 0 0\n}\n\n.start-rating ul {\n\tpadding: 0;\n\tlist-style: none;\n\tmargin: 7px 0 0\n}\n\n.start-rating ul li {\n\tmargin-top: 5px;\n\tfont-size: 12px\n}\n\n#google-reviews .row {\n\tdisplay: flex;\n\tmargin: 0\n}\n\n.average-rating {\n\ttext-align: center;\n\twidth: 35%\n}\n\n.rating {\n\tborder: none;\n\tpadding: 5px 0;\n\twidth: 100px;\n\tmargin: auto\n}\n\n.average {\n\tfont-size: 36px;\n\tmargin-top: 20px\n}\n\n.all-reviews {\n\tfont-size: 12px;\n\tcolor: #2e3a59\n}\n\n#google-reviews p {\n\tmargin-bottom: 5px\n}\n\n.reviews__content {\n\tpadding: 0;\n\tlist-style: none;\n\tmargin: 20px 0 0\n}\n\n.reviews__content::-webkit-scrollbar {\n\twidth: 5px;\n\tposition: relative;\n\ttop: 30px\n}\n\n.reviews__content::-webkit-scrollbar-thumb {\n\tbackground: #a6a6a6;\n\tposition: relative;\n\ttop: 30px\n}\n\n.reviews__content::-webkit-scrollbar-thumb:hover {\n\tbackground: #c4161c\n}\n\n.reviews__content li {\n\tmargin: 0 0 20px;\n\tpadding: 10px 12px 15px;\n\tbackground: #f7f9fc;\n\tborder-radius: 0 30px 0 30px\n}\n\n.heading {\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 30px;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n\tfont-family: rajdhani, sans-serif;\n\tcolor: #505050\n}\n\n.eyecheckup-btn {\n\ttext-align: right\n}\n\n.badge-pill {\n\tpadding: .5em 1em;\n\tfont-size: 10px;\n\tfont-weight: 400;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tborder-radius: 0\n}\n\n.badge-light {\n\tcolor: #000;\n\tbackground-color: #f4f4f4;\n\tborder: 1px solid #adadad\n}\n\n.star-ratings-css {\n\tunicode-bidi: bidi-override;\n\tcolor: #c5c5c5;\n\tfont-size: 25px;\n\theight: 25px;\n\twidth: 100px;\n\tmargin: 0 auto;\n\tposition: relative;\n\tpadding: 0;\n\ttext-shadow: 0 1px 0 #a2a2a2\n}\n\n.store-tags h3 {\n\tfont-size: 20px;\n\tmargin-bottom: 20px;\n\tborder-bottom: 1px solid #adadad;\n\tpadding-bottom: 10px;\n\tfont-weight: 600;\n\tfont-family: rajdhani, sans-serif\n}\n\n.star-ratings-css-top {\n\tcolor: #e7711b;\n\tpadding: 0;\n\tposition: absolute;\n\tz-index: 1;\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\toverflow: hidden\n}\n\n.star-ratings-css-bottom {\n\tpadding: 0;\n\tdisplay: block;\n\tz-index: 0\n}\n\n.star-ratings-sprite {\n\tfont-size: 0;\n\theight: 21px;\n\tline-height: 0;\n\toverflow: hidden;\n\ttext-indent: -999em;\n\twidth: 80px;\n\tmargin: 0 auto;\n\tbackground-size: 16px\n}\n\n.star-ratings-sprite-rating {\n\tfloat: left;\n\theight: 18px;\n\tdisplay: block;\n\tbackground-size: 16px\n}\n\n.reviews__review-er.avatar_image {\n\twidth: 55px;\n\tborder-radius: 50%;\n\tmargin-right: 15px;\n\tfloat: left;\n\tborder: 1px solid #eee;\n\tpadding: 0;\n\tmargin-top: 0\n}\n\n.reviews__review-er {\n\tmargin-bottom: 7px;\n\tcolor: #2e3a59;\n\tmargin-top: 9px;\n\tfont-size: 16px\n}\n\n.detail-search p {\n\tfont-weight: 400;\n\tline-height: 20px\n}\n\n.store-container {\n\toverflow: hidden;\n\tdisplay: flex\n}\n\n.reviews__review-date {\n\tfont-size: 10px;\n\tfont-weight: 400;\n\tmargin-top: 3px;\n\tposition: absolute;\n\tright: 0\n}\n\n.reviews__review-comment {\n\tmargin-top: 6px;\n\tfont-weight: 400;\n\tfont-size: 12px;\n\tline-height: normal;\n\tclear: both\n}\n\n.reviews__review-rating {\n\tfont-weight: 300;\n\tfont-size: 11px;\n\tdisplay: flex;\n\tposition: relative\n}\n\n.user-rating {\n\twidth: 80px\n}\n\n.user-rating .star-ratings-sprite-rating {\n\tfloat: none;\n\tdisplay: inline-block\n}\n\n.toggle-content {\n\tdisplay: none\n}\n\n.toggle {\n\tcolor: #c4161c;\n\ttext-decoration: underline\n}\n\n.user_login_message {\n\tfont-family: rajdhani, sans-serif;\n\tcolor: #e81445\n}\n\n.store-name {\n\tpadding: 12px 12px 4px;\n\tposition: absolute;\n\tbottom: -27px;\n\tleft: 0;\n\tright: 0\n}\n\n.store-name span {\n\tdisplay: block\n}\n\n.store-name span {\n\tcolor: #c4161c;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tfont-family: futura book;\n\ttext-decoration: none;\n\tpadding-bottom: 5px;\n\tposition: static\n}\n\n#appointment-modal h4 {\n\ttext-align: center;\n\tfont-size: 16px;\n\tmargin-bottom: 20px;\n\tborder-bottom: 1px solid #e4e9f2;\n\tmargin: 0 -16px 16px;\n\tpadding-bottom: 12px;\n\tfont-weight: 600\n}\n\n#appointment .input-block {\n\tmargin-bottom: 20px;\n\tmargin-top: 20px\n}\n\n#video_appointment .input-block {\n\tmargin-bottom: 20px;\n\tmargin-top: 20px\n}\n\n#appointment .input-block label {\n\twidth: 40%;\n\tfont-weight: 400\n}\n\n#video_appointment .input-block label {\n\twidth: 40%;\n\tfont-weight: 400\n}\n\n#appointment .input-block input,\n.optional input,\n.chosen-select {\n\twidth: 59%;\n\theight: 35px;\n\tbackground: #f7f9fc;\n\tcolor: #222b45;\n\tfont-size: 13px;\n\tborder-radius: 4px;\n\tfont-weight: 400;\n\tborder: 1px solid #e4e9f2;\n\tpadding: 0 5px\n}\n\n#video_appointment .input-block input,\n.optional input,\n.chosen-select {\n\twidth: 59%;\n\theight: 35px;\n\tbackground: #f7f9fc;\n\tcolor: #222b45;\n\tfont-size: 13px;\n\tborder-radius: 4px;\n\tfont-weight: 400;\n\tborder: 1px solid #e4e9f2;\n\tpadding: 0 5px\n}\n\n.optional {\n\tpadding: 6px 0\n}\n\n.optional input {\n\twidth: 100%\n}\n\n#appointment fieldset {\n\tmargin-bottom: 10px\n}\n\n#video_appointment fieldset {\n\tmargin-bottom: 10px\n}\n\n.select-day-time {\n\tborder: 1px solid #eee;\n\tpadding: 20px 15px 10px\n}\n\n.day-block {\n\tdisplay: inline-block;\n\twidth: 13.6%;\n\ttext-align: center;\n\tpadding: 10px 0;\n\ttransition: .4s;\n\tcursor: pointer;\n\tbackground: #000;\n\tcolor: #fff;\n\tmargin: 0 !important\n}\n\n.day-block span {\n\tdisplay: block;\n\tmargin: 6px 0\n}\n\n.time-slot {\n\tdisplay: inline-block;\n\twidth: 24.2%;\n\ttext-align: center;\n\tborder: 2px solid #e4e9f2;\n\tpadding: 10px;\n\tfont-weight: 400;\n\tpadding: 15px 0;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: .4s;\n\tfont-size: 12px;\n\tfont-weight: revert\n}\n\n.time-slot:hover,\n.time-slot.active {\n\tborder: 2px solid #c4161c;\n\tcolor: #c4161c\n}\n\n.whats-rem input[type=checkbox]+label {\n\tdisplay: block;\n\tmargin: .2em;\n\tcursor: pointer;\n\tpadding: .2em\n}\n\n.whats-rem input[type=checkbox] {\n\tdisplay: none\n}\n\n.whats-rem input[type=checkbox]+label:before {\n\tcontent: \"\\2714\";\n\tborder: .1em solid #000;\n\tborder-radius: .2em;\n\tdisplay: inline-block;\n\twidth: 18px;\n\theight: 18px;\n\tpadding-left: 0;\n\tpadding-bottom: 0;\n\tmargin-right: 5px;\n\tvertical-align: bottom;\n\tcolor: transparent;\n\ttransition: .2s;\n\tmargin-top: 15px\n}\n\n.whats-rem input[type=checkbox]+label:active:before {\n\ttransform: scale(0)\n}\n\n.whats-rem input[type=checkbox]:checked+label:before {\n\tbackground-color: MediumSeaGreen;\n\tborder-color: MediumSeaGreen;\n\tcolor: #fff\n}\n\n.day-block:hover,\n.day-block.active {\n\tbackground: #c9edea\n}\n\n.modal-dialog {\n\tmax-width: 700px\n}\n\n.submitBtnLead {\n\tmargin-top: -10px;\n\tfont-weight: 400;\n\tpadding: 12px 10px;\n\tcursor: pointer;\n\tposition: relative;\n\ttop: -8px\n}\n\n.time-slot-field,\n.day-group {\n\ttext-align: center\n}\n\n.time-slot-field label,\n.day-group label {\n\tmargin: 18px 0 15px;\n\tcolor: #505050\n}\n\n.day-group label {\n\tmargin-top: 0\n}\n\n.disabled {\n\tcursor: not-allowed;\n\tcursor: not-allowed\n}\n\n.disabled:hover {\n\tborder-color: #e4e9f2;\n\tcolor: #444\n}\n\ndiv#mapFullScreen div {\n\tcolor: #f7f9fc !important\n}\n\n.mobileview {\n\tdisplay: none\n}\n\n.tel span {\n\tbackground: #ed1b24;\n\tpadding: 1px 15px;\n\tcolor: #fff;\n\tfloat: right;\n\tmargin-right: 0;\n\tfont-size: 13px;\n\tmargin-left: 30px\n}\n\n#scroll {\n\tposition: fixed;\n\tright: 10px;\n\tbottom: 10px;\n\tcursor: pointer;\n\twidth: 50px;\n\theight: 50px;\n\tbackground-color: #c4161c;\n\ttext-indent: -9999px;\n\tdisplay: none;\n\t-webkit-border-radius: 60px;\n\t-moz-border-radius: 60px;\n\tborder-radius: 60px\n}\n\n#scroll span {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-left: -8px;\n\tmargin-top: -12px;\n\theight: 0;\n\twidth: 0;\n\tborder: 8px solid transparent;\n\tborder-bottom-color: #fff\n}\n\n#scroll:hover {\n\tbackground-color: #f26522;\n\topacity: 1;\n\tfilter: \"alpha(opacity=100)\";\n\t-ms-filter: \"alpha(opacity=100)\"\n}\n\na#whatsappimage {\n\tdisplay: none\n}\n\n.loc-pin {\n\tmax-width: 5%\n}\n\n.eyecheckup {\n\tbackground: linear-gradient(80deg, #31b2b0, #edbc31)\n}\n\n.eyecheckup:hover {\n\tbackground: linear-gradient(80deg, #31b2b0, #edbc31)\n}\n\n@media all and (max-width: 1024px) and (min-width: 768px) {\n\t.payment ul li {\n\t\tfont-size: 10px\n\t}\n\n\t.store-name span {\n\t\tfont-size: 14px\n\t}\n\n\t.rating-process {\n\t\twidth: 40%\n\t}\n\n\t.average {\n\t\tfont-size: 32px\n\t}\n\n\t.start-rating ul li {\n\t\tmargin-top: 6px\n\t}\n\n\t.reviews__review-date {\n\t\tposition: static;\n\t\tpadding-top: 30px\n\t}\n\n\t.reviews__review-rating {\n\t\tdisplay: block\n\t}\n\n\t#content.detail-search .nearby-stores-content .store-info {\n\t\twidth: 50%\n\t}\n\n\t.heading {\n\t\tfont-size: 26px\n\t}\n\n\t.user-rating {\n\t\tposition: absolute;\n\t\tleft: 67px\n\t}\n\n\t.tabletview {\n\t\tfloat: right\n\t}\n\n\t.navbar-brand {\n\t\tpadding: 0\n\t}\n\n\t.upper-part .btn {\n\t\tfloat: right;\n\t\tmargin-top: 12px\n\t}\n\n\t.upper-part .col-md-12.d-md-flex {\n\t\tdisplay: block !important\n\t}\n}\n\n@media all and (max-width: 767px) {\n\t.slot-hint {\n\t\tmargin-bottom: 20px;\n\t\tpadding-left: 0\n\t}\n\n\t.new-popup-form .time-slot:before {\n\t\twidth: 76px;\n\t\ttext-align: center;\n\t\tfont-size: 10px;\n\t\tpadding: 0\n\t}\n\n\t.new-popup-form .time-slot-field:last-child {\n\t\ttext-align: left;\n\t\tmargin: 5px 0 0\n\t}\n\n\t#free-eyecheckup {\n\t\twidth: auto;\n\t\ttext-align: right;\n\t\tfont-size: 12px;\n\t\tmargin-top: 9px;\n\t\tdisplay: none !important;\n\t\ttext-transform: uppercase;\n\t\tfont-family: Rajdhani, sans-serif;\n\t\tfont-weight: 600;\n\t\tborder: 1px solid #c9edea;\n\t\tborder-radius: 25px;\n\t\tpadding: 10px 8px 3px 10px;\n\t\tbackground: #c9edea;\n\t\tbox-shadow: 0 2px 20px rgba(46, 229, 157, .4);\n\t\tcursor: pointer\n\t}\n\n\t#free-eyecheckup i.fa.fa-whatsapp {\n\t\tcolor: #4ac959;\n\t\tfont-size: 20px;\n\t\tfloat: right;\n\t\tmargin-left: -17px;\n\t\tpadding-left: 23px;\n\t\tmargin-top: -4px\n\t}\n\n\t#free-eyecheckup a {\n\t\tcolor: #505050;\n\t\ttext-decoration: none;\n\t\tfont-weight: 700\n\t}\n\n\t.navbar-brand {\n\t\tpadding: 0;\n\t\twidth: 50%;\n\t\tmargin-right: 0\n\t}\n\n\t.upper-part .btn {\n\t\tfloat: right;\n\t\tmargin-top: 13px\n\t}\n\n\t.upper-part .col-md-12.d-md-flex {\n\t\tdisplay: block !important\n\t}\n\n\t.tel-mobile img {\n\t\twidth: 25px\n\t}\n\n\t.lenskart-offer-desk.showthis.home.desktopview {\n\t\tdisplay: none\n\t}\n\n\t#scroll {\n\t\tright: 22px;\n\t\tbottom: 60px\n\t}\n\n\ta#whatsappimage {\n\t\tdisplay: block;\n\t\tposition: fixed;\n\t\tbottom: 10px;\n\t\tright: 22px\n\t}\n\n\ta#whatsappimage img {\n\t\tfilter: drop-shadow(2px 2px 2px #989898);\n\t\twidth: 135px\n\t}\n\n\tul#reviews__content,\n\t.list-view-sidebar {\n\t\theight: auto;\n\t\toverflow-y: initial\n\t}\n\n\t#google-reviews {\n\t\tmargin-top: 30px\n\t}\n\n\t.modal-open .modal {\n\t\tpadding-right: 0 !important\n\t}\n\n\t.day-block {\n\t\twidth: 13%\n\t}\n\n\t.time-slot {\n\t\twidth: 49%;\n\t\tmargin-bottom: 10px\n\t}\n\n\t#appointment .input-block input,\n\t.optional input,\n\t.chosen-select {\n\t\twidth: 53%\n\t}\n\n\t#video_appointment .input-block input,\n\t.optional input,\n\t.chosen-select {\n\t\twidth: 53%\n\t}\n\n\t#video_appointment .input-block label {\n\t\twidth: 44%\n\t}\n\n\t#appointment .input-block label {\n\t\twidth: 44%\n\t}\n\n\t.mobileview {\n\t\tdisplay: block\n\t}\n\n\t.desktopview {\n\t\tdisplay: none\n\t}\n\n\ta.tel-mobile {\n\t\tmargin: 12px 0 0 8px\n\t}\n}\n\n@media all and (max-width: 479px) {\n\n\t.heading,\n\t#content.detail-search h1 {\n\t\tfont-size: 24px\n\t}\n\n\t.heading,\n\t#content.detail-search h1 {\n\t\ttext-align: center\n\t}\n\n\t.upper-part .btn {\n\t\tfont-size: 11px\n\t}\n\n\t.imgs-grid .imgs-grid-image .image-wrap {\n\t\tdisplay: block\n\t}\n}\n\n@media all and (max-width: 360px) {\n\t.select-day-time {\n\t\tpadding-right: 8px;\n\t\tpadding-left: 8px\n\t}\n}\n\n@media all and (max-width: 359px) {\n\t.day-block {\n\t\twidth: 12%\n\t}\n\n\t#free-eyecheckup {\n\t\tfont-size: 10px;\n\t\tmargin-top: 10px\n\t}\n}\n\n.ant-card-head {\n\tbackground-color: #00000014;\n\tborder-bottom: 1px solid #00000014 !important;\n\tmin-height: unset;\n\n}\n\n\n\n.ant-card {\n\tmin-height: 120px;\n\tborder: 1px solid #00000014 !important;\n\tborder-radius: .35rem;\n\tbox-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;\n\n}\n\n.ant-card-head-title {\n\tfont-family: 'Merriweather Sans', sans-serif;\n}\n\n\n\n.ant-row-center {\n\tjustify-content: unset;\n}\n\n.ant-layout-header {\n\theight: unset !important;\n}\n\n.ant-card-head {\n\tpadding: unset;\n}\n\n.ant-layout-content-center {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.ant-layout-content-login form {\n\tmargin-top: 60px;\n\twidth: 400px;\n\tborder: 1px solid #053380 !important;\n\tborder-radius: .35rem;\n\tpadding: 20px;\n\tbox-shadow: 0 .15rem 1.75rem 0 rgba(58, 59, 69, .15) !important;\n}\n\n.ant-form-item-control-input-content-login button {\n\twidth: 100%\n}\n\n.ant-col-24.ant-form-item-label {\n\tpadding: 0px;\n}\n\n.ant-layout-content form label {\n\tfont-size: var(--font-size-base);\n\tfont-weight: 500;\n\tcolor: var(--color-text);\n}\n\n.ant-form-item-explain-error {\n\tfont-size: var(--font-size-sm);\n\tfont-weight: 500;\n\tcolor: var(--color-error) !important;\n}\n\n.ant-form-item-has-error .ant-input-affix-wrapper,\n.ant-form-item-has-error .ant-input,\n.ant-form-item-has-error .ant-picker {\n\tborder-color: var(--color-error);\n}\n\n/* .ant-input {padding: 8px 11px !important;} */\n\n/* dashboard report cards: light pastel backgrounds (set per row in the report files) with dark readable text */\n.report-card {\n\theight: 200px;\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.report-card .ant-card-head {\n\tcolor: var(--color-text);\n\tborder-bottom-color: rgba(0, 0, 0, 0.12);\n}\n\n.report-card .ant-card-head-title {\n\tpadding: 10px;\n\tfont-size: var(--font-size-sm);\n\tcolor: var(--color-text) !important;\n\tfont-weight: 600;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.report-card .ant-card-body {\n\ttext-align: center;\n\tpadding: 16px 12px;\n}\n\n.report-card .ant-card-body a {\n\tcolor: var(--color-brand-dark) !important;\n\tfont-size: var(--font-size-stat);\n\tfont-weight: 600;\n\ttext-decoration: none;\n}\n\n.report-card .ant-card-body a:hover {\n\ttext-decoration: underline;\n}\n\n.report-card .ant-card-body hr {\n\tborder-color: rgba(0, 0, 0, 0.3);\n\tmargin: 6px 0;\n}\n\n/* tables on the listing pages */\nbutton + .ant-table-wrapper,\n.ant-space + .ant-table-wrapper {\n\tmargin-top: 16px;\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th.ant-table-cell {\n\tbackground: #eef2f8;\n\tcolor: #1f2937;\n\tfont-weight: 600;\n}\n\n.ant-table-wrapper .ant-table-tbody > tr > td.ant-table-cell {\n\tpadding: 10px 12px;\n\tword-break: break-word;\n}\n\n.ant-table-wrapper .ant-table-tbody > tr:hover > td.ant-table-cell {\n\tbackground: #f5f8ff;\n}\n\n/* app background */\nbody {\n\tbackground-color: var(--color-bg-app);\n\tcolor: var(--color-text);\n\tfont-size: var(--font-size-base);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
